import React, { useState } from 'react'
import { useQuery } from 'react-query'
import { useLocation } from 'react-router-dom'

import AdasReports from './AdasReports'
import UploadModal from './UploadModal'
import { ContainerProvider } from '../../containerContext'
import { useApi } from '../../../hooks'
import useAppContext from '../../app'

const queryOrigin = {
  query: {
    page: 1,
    limit: 50,
    filter: {
      status: 'all',
      search: '',
    },
  },
  sorted: {
    sortBy: 'dateCreated',
    sortDirection: 'desc',
  },
}

const Index = () => {
  const [state, setState] = useState({ ...queryOrigin })
  const { adasReportService } = useApi()
  const { store: { clientSettings } } = useAppContext()
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const [showUpload, setShowUpload] = useState(params.get('upload') === 'true')

  const allowUpload = clientSettings && clientSettings.vehicleReports && clientSettings.vehicleReports.allowUpload
  // Company entitlement (active subscription or gift credits) — also gates the
  // modal so the ?upload=true URL param can't bypass the disabled button.
  const hasAdasCredits = clientSettings && clientSettings.vehicleReports && clientSettings.vehicleReports.hasAdasCredits

  const {
    isLoading,
    data = {},
    refetch,
  } = useQuery(
    ['adasReports', state.query, state.sorted],
    () => {
      const { filter, ...otherQuery } = state.query
      const params = {
        ...otherQuery,
        sortBy: state.sorted.sortBy,
        sortOrder: state.sorted.sortDirection === 'desc' ? -1 : 1,
      }

      if (filter.status && filter.status !== 'all') params.status = filter.status
      if (filter.search) params.search = filter.search
      if (filter.vendor && filter.vendor !== 'all') params.vendor = filter.vendor
      if (filter.insuranceCarrier && filter.insuranceCarrier !== 'all') params.insuranceCarrier = filter.insuranceCarrier
      if (filter.source && filter.source !== 'all') params.source = filter.source
      if (filter.startDate) params.dateFrom = filter.startDate
      if (filter.endDate) params.dateTo = filter.endDate

      return adasReportService.many(params)
    },
    {
      refetchOnWindowFocus: false,
    },
  )

  return (
    <ContainerProvider
      state={state}
      setState={setState}
      data={data.vehicleReports || []}
      stateOrigin={queryOrigin}
      isLoading={isLoading}
      total={data.total || 0}
      pricingByVendor={data.pricingByVendor || {}}
      onUpload={() => setShowUpload(true)}
    >
      <AdasReports onUpload={() => setShowUpload(true)} />
      {allowUpload && hasAdasCredits && (
        <UploadModal
          show={showUpload}
          onHide={() => setShowUpload(false)}
          onSuccess={refetch}
        />
      )}
    </ContainerProvider>
  )
}

export default Index
